import {omit} from 'external/lodash'
import icons from 'components/Menu/icons'

export default function Icon (props) {
  const MyIcon = icons[props.name]
  return MyIcon
    ? (<MyIcon {...omit(props, ['name'])} />)
    : (<label>Missing icon</label>)
}
